import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import openai from './pictures/openAI.jpeg';
import firesideChat from './pictures/firesideChat.jpeg';

const OpenAIFireside = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC x OpenAI: Breakfast & Fireside Chat!</h2>
                    <p class="site-post-meta">October 3, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>

                    Thank you to everyone who joined us for our recent event in collaboration with OpenAI! We had a wonderful time connecting with engineers at OpenAI, hearing about their experiences and learning more about the inner workings of the company, while also grabbing breakfast as well!

                    <br></br>
                    <br></br>


                    The highlight of the event was definitely learning so much more about what it is like to work at OpenAI from an insiders perspective. We got to hear about what they were working on and how working at OpenAI has changed the way they approach problems and their outlook on tech and the future of AI.
                    
                    
                    <br></br>
                    <br></br>
                    
                    
                    We're so grateful to the multiple engineers and recruiter for speaking with us, sharing their experience, and offering advice. It was an amazing opportunity to ask one-on-one questions, learn more about the company, and imagine what working at OpenAI would be like. Thank you to everyone who joined!
                    
                    
                    </p>
                    <img src={openai} alt="Attendees at Open AI fireside chat event."/>
                    <img src={firesideChat} alt="Recruiter talking with engineer during fireside chat."/>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default OpenAIFireside;
